const mapEngagement = ({
	canvasEngagementId: id,
	engagementDescription: description,
	gaRoleTypeId: roleType = 0,
	clientName
}) => ({
	id,
	description,
	roleType,
	clientName
});

export default ({allClients}) => {
	if (!allClients.data) return null;

	let engs = [];

	allClients.data.forEach(
		({engagements, clientName}) => (engs = [...engs, ...engagements.map((e) => ({...e, clientName}))])
	);

	return engs.map(mapEngagement);
};
